import * as CL from '@design-system/component-library';
import { useLoaderData, useNavigate } from 'react-router';
import { dsClass } from '../../common/constants/dsClasses.js';
import { paths } from '../../common/constants/pathVariables.js';
import { t } from '../../common/i18n';
import { useAuth } from '../../public/site/AuthProvider';
import { CaseList } from '../CaseList/CaseList';
import type { SupportCasesResponse } from '../../generated/api/supportCasesResponse';

export const SupportCasesAndMessages = () => {
  const navigate = useNavigate();
  const { authenticatedUser } = useAuth();
  const {
    searchResults: supportCases,
    resultCountAggregations: aggregations,
    total: totalItems,
  } = useLoaderData() as SupportCasesResponse;

  return (
    <div className="of-support-cases-and-messages">
      <CL.NotificationBanner
        text={t.OLM4(
          'We are currently developing OmaElisa for Companies. The list below shows the support requests you have submitted through the "Ask about the invoice" and "Create new" options.'
        )}
        icon={<CL.Icon icon="information" size="m" type="regular" color="blue-600" />}
      />
      <div className={`create-case-button ${dsClass.MARGIN_TOP_3}`}>
        <CL.Button
          icon={<CL.Icon className={dsClass.MARGIN_RIGHT_2} icon="new-message" />}
          onClick={() => navigate(paths.MESSAGE_CENTER_SUPPORT_CASE_NEW)}
        >
          {t.TFDQ('Create new')}
        </CL.Button>
      </div>
      <CaseList
        supportCases={supportCases}
        aggregations={aggregations}
        totalItems={totalItems}
        authenticatedUser={authenticatedUser}
      />
    </div>
  );
};
